/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { hot } from 'react-hot-loader';

function ButtonColumns(props) {
	return (
		<Grid className="no-shadow" container id="reduce-width" justify="center" spacing={2}>
			{props.children}
		</Grid>
	);
}

export default hot(module)(ButtonColumns);
